export default __webpack_public_path__ + "static/media/check-round-purple.f9bd3f79.svg";